import React, { useState } from "react";
import { signInUser } from "../../utils/firebase";
import { useNavigate, Link } from "react-router-dom";
import toast from "react-hot-toast";

const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await signInUser(email, password);
      toast.success("Connexion réussie !");
      navigate("/");
    } catch (error) {
      toast.error("Erreur de connexion.");
      console.error(error);
    }
  };

  return (
    <div className="flex h-screen w-full items-center justify-center bg-gray-50">
      <div className="bg-white p-8 shadow-lg rounded-xl w-96">
        <h2 className="text-2xl font-semibold mb-6">Connexion</h2>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="border rounded-md px-3 py-2 w-full mb-4"
        />

        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="border rounded-md px-3 py-2 w-full mb-6"
        />

        <button
          onClick={handleLogin}
          className="w-full bg-black text-white py-2 rounded-md hover:bg-gray-800 transition duration-150"
        >
          Se connecter
        </button>

        <p className="text-center mt-4 text-sm text-gray-600">
          Pas encore inscrit ?{" "}
          <Link className="text-blue-500 underline" to="/signup">
            Créer un compte
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
